import { useEffect, useRef, useState } from "react"
import {
  AddIngredientButton,
  IngredientList,
  Label,
  Placeholder,
  StyledIngredients,
  StyledSwipeAction,
} from "./styled"
import PlusIcon from "components/Icons/PlusIcon"
import { FoodListDivider } from "components/foodItem/FoodListItem/styled"
import { SwipeActionRef } from "antd-mobile"
import TrashIcon from "components/Icons/TrashIcon"
import Ingredient from "./Ingredient"
import { IngredientOptionType } from "model/food/types"

interface ISwipeIngredientProps {
  ingredient: IngredientOptionType
  swipedId: any
  setSwipedId: (id: any) => void
  onRemove: () => void
  onViewDetails: (ingredient: IngredientOptionType) => void
  isManualNutrition?: boolean
}

const SwipeIngredientItem = (props: ISwipeIngredientProps) => {
  const {
    ingredient,
    swipedId,
    setSwipedId,
    onRemove,
    onViewDetails,
    isManualNutrition = false,
  } = props

  useEffect(() => {
    if (swipedId && swipedId !== ingredient.uuid) {
      ref.current?.close()
    }
  }, [swipedId])

  const ref = useRef<SwipeActionRef>(null)

  return (
    <StyledSwipeAction
      closeOnTouchOutside={false}
      ref={ref}
      onActionsReveal={() => {
        setSwipedId(ingredient.uuid)
      }}
      closeOnAction={false}
      rightActions={[
        {
          key: "delete",
          text: <TrashIcon />,
          color: "danger",
          onClick: onRemove,
        },
      ]}
    >
      {" "}
      <Ingredient
        ingredient={ingredient}
        hideAddBtn={true}
        style={{ paddingLeft: 8, paddingRight: 8 }}
        onSelect={isManualNutrition ? undefined : onViewDetails}
        hasArrow={true}
        isManualNutrition={isManualNutrition}
      />
    </StyledSwipeAction>
  )
}

interface IIngredientsProps {
  ingredients: IngredientOptionType[]
  showSearchIngredients: () => void
  onRemoveIngredient: (id: string) => void
  onViewIngredientDetails: (ingredient: IngredientOptionType) => void

  isManualNutrition?: boolean
}

const Ingredients = (props: IIngredientsProps) => {
  const {
    ingredients,
    showSearchIngredients,
    onRemoveIngredient,
    onViewIngredientDetails,
    isManualNutrition = false,
  } = props
  const [swipedId, setSwipedId] = useState<any>(null)
  return (
    <StyledIngredients>
      <Label>Ingredients</Label>

      <AddIngredientButton
        onClick={showSearchIngredients}
        fill="outline"
        style={{
          "--border-color": "#0da3ba",
        }}
      >
        <PlusIcon />
        Add Ingredients
      </AddIngredientButton>
      {!ingredients.length && (
        <Placeholder>Add ingredients to calculate your nutrition</Placeholder>
      )}

      {ingredients.length ? (
        <IngredientList>
          {ingredients.map((ingredient, index: number) => (
            <div key={ingredient.uuid}>
              <SwipeIngredientItem
                isManualNutrition={isManualNutrition}
                onViewDetails={() => onViewIngredientDetails(ingredient)}
                ingredient={ingredient}
                swipedId={swipedId}
                setSwipedId={setSwipedId}
                onRemove={() => onRemoveIngredient(ingredient.uuid as string)}
              />
              {index !== ingredients.length - 1 && <FoodListDivider />}
            </div>
          ))}
        </IngredientList>
      ) : null}
    </StyledIngredients>
  )
}

export default Ingredients
